import { defineStore } from 'pinia'

export const useNotificationsStore = defineStore('notificationsStore', () => {
  const count = ref(null)
  const newNotification = ref(null)

  function setCount(newCount: number) {
    count.value = newCount
    setFavicon(newCount)
  }

  function setNewNotification(notification: any) {
    newNotification.value = notification
  }

  const setFavicon = (count: number) => {
    const iconPath =
      count > 0
        ? '/images/favicon_transkribus_notification.svg'
        : '/images/favicon_transkribus.svg'
    let favicon = document.querySelector('link[rel="icon"]')
    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }
    favicon.href = iconPath
  }

  return {
    count,
    setCount,
    newNotification,
    setNewNotification,
  }
})
